'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CollapsibleModule = require('./CollapsibleModule');

var _CollapsibleModule2 = _interopRequireDefault(_CollapsibleModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CollapsibleModule2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CollapsibleModule/index.js
// module id = 564
// module chunks = 11